import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {name} from '@management-ui/core'
import {styled} from '@mui/styles';

const Container = styled('ul')(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  listStyle: 'none',
  margin: `${theme.spacing(2)} 0 0`,
  padding: 0,
}));

const User = styled('li')(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  display: 'flex',
  flex: `0 0 calc(25% - ${theme.spacing(1)})`,
  flexWrap: 'wrap',
  opacity: 0.5,
  overflow: 'hidden',
  textAlign: 'center',
  transition: '0.25s opacity ease-in-out',
  width: `calc(25% - ${theme.spacing(1)})`,

  '&.active': {
    opacity: 1,
  },

  '& h4': {
    flex: '0 0 100%',
    margin: 0,
    padding: theme.spacing(1),
    width: '100%',
  },

  '& span': {
    flex: '0 0 50%',
    fontWeight: 600,
    padding: theme.spacing(1),
    width: '50%',

    '&.pending': {
      backgroundColor: theme.palette.taskStatus.pending.main,
      color: theme.palette.taskStatus.pending.contrastText,
    },

    '&.overdue': {
      backgroundColor: theme.palette.taskStatus.overdue.main,
      color: theme.palette.taskStatus.overdue.contrastText,
    }
  }
}))

const ProgressSummary = ({users, selected, onSelect}) => {
  const user = useSelector(state => state['auth'].user);
  const userCanManage = useMemo(() => user.permissions.can_manage_tasks, [user]);

  const handleSelect = useCallback((assignee) => {
    onSelect(assignee === selected ? '' : assignee);
  }, [selected, onSelect]);

  return userCanManage && users.length > 0 ? (
    <Container>
      {users.map((user, index) => (
        <User
          className={selected === user.id || selected === '' ? 'active' : ''}
          key={index}
          onClick={() => handleSelect(user.id)}
        >
          <h4>{name(user)}</h4>
          <span className="pending">{user.pending} / {user.total}</span>
          <span className="overdue">{user.overdue} / {user.total}</span>
        </User>
      ))}
    </Container>
  ) : null
}

export default ProgressSummary;